import React from "react";

function InvoiceIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      {...props}
    >
      <g id="invoice" transform="translate(6.001 -0.01)">
        <rect
          id="Rectangle_92"
          data-name="Rectangle 92"
          width="40"
          height="40"
          transform="translate(-6.001 0.01)"
          fill="none"
        />
        <path
          id="Path_425"
          data-name="Path 425"
          d="M27.645.08a2.484,2.484,0,0,1,2.035,1.359A2.733,2.733,0,0,1,29.9,2.7c-.016,2.043.094,4.084.02,6.13-.082,2.264.065,4.53.019,6.8-.054,2.685.062,5.373.017,8.06-.025,1.471,0,2.944.062,4.412a2.139,2.139,0,0,1-.72,1.781c-1.554,1.5-3.042,3.076-4.58,4.6-1.695,1.68-3.361,3.387-5.035,5.088a1.122,1.122,0,0,1-.869.365c-2.293-.027-4.583.118-6.879.023-1.4-.057-2.81.007-4.215.047-1.742.048-3.481-.076-5.224-.023a2.4,2.4,0,0,1-1.894-.9,2.32,2.32,0,0,1-.5-1.647c0-2.043-.1-4.084-.026-6.13.083-2.29-.093-4.582-.012-6.878.08-2.316-.1-4.635-.015-6.957.079-2.277-.071-4.556-.019-6.838C.094,8.026.016,5.416,0,2.809A2.634,2.634,0,0,1,2.659.09C4.4.1,6.14.052,7.881.1c2,.052,4-.079,6.011-.01,2.356.08,4.714-.118,7.074-.009.982.045,1.97-.017,3.208-.033C25.162.1,26.4-.084,27.645.081Zm-.171,27.213c.053-3.041-.068-6.083-.022-9.123.034-2.307-.1-4.613-.022-6.916.079-2.282-.062-4.559-.015-6.838.011-.545.037-1.091.048-1.637,0-.208-.06-.29-.266-.253a.251.251,0,0,1-.04,0c-3.264.079-6.529.014-9.793.032-2.647.016-5.3.087-7.94.028-2.217-.05-4.428.054-6.641.026-.256,0-.326.065-.319.324.111,3.618.028,7.238.054,10.857.02,2.7.082,5.4.028,8.1-.046,2.282.1,4.561.02,6.838-.081,2.321.06,4.638.015,6.957-.009.505-.047,1.011-.046,1.519,0,.153,0,.235.214.271a6.188,6.188,0,0,0,1.126.048c1.747-.021,3.5-.105,5.24-.055,2.426.07,4.848-.039,7.271-.029.3,0,.586.087.888.07.177-.01.277-.041.241-.24a.658.658,0,0,1,0-.079c-.036-2.371.055-4.742-.01-7.114a2.464,2.464,0,0,1,2.586-2.611c2.308.1,4.611-.043,6.917-.03a.9.9,0,0,1,.455.1c0-.116.008-.179.009-.244ZM25.7,30.058c-.067-.042-.095-.074-.123-.074q-2.628-.008-5.257-.01c-.145,0-.31-.058-.3.215.043,1.778-.083,3.557,0,5.335a.534.534,0,0,0,.034.105c1.96-1.794,3.672-3.8,5.65-5.569Z"
          transform="translate(0 0)"
          fill="currentColor"
        />
        <path
          id="Path_427"
          data-name="Path 427"
          d="M56.925,263.314a1.04,1.04,0,0,0-.011-.4c-.05-.105-.222-.064-.335-.109a2.829,2.829,0,0,1-.752-.418.66.66,0,0,1-.128-.92.652.652,0,0,1,.918-.133,1.476,1.476,0,0,0,1.321.282,1.325,1.325,0,0,0,.859-.679.665.665,0,0,0-.123-.763,1.323,1.323,0,0,0-1.052-.482,6.246,6.246,0,0,1-1.174-.181.939.939,0,0,1-.332-.158,2.269,2.269,0,0,1-1.2-2,2.174,2.174,0,0,1,.828-1.576,2.317,2.317,0,0,1,.97-.509c.1-.027.144-.07.139-.181-.009-.192-.005-.385,0-.577a.656.656,0,0,1,.469-.653.626.626,0,0,1,.7.256c.2.216.145.457.149.7.006.354,0,.353.327.469a2.646,2.646,0,0,1,.773.422.654.654,0,0,1,.141.9.642.642,0,0,1-.927.154,1.584,1.584,0,0,0-1.343-.287,1.271,1.271,0,0,0-.745.481.723.723,0,0,0,0,.933,1.374,1.374,0,0,0,1.3.5,1.975,1.975,0,0,1,.823.147A2.506,2.506,0,0,1,60,259.814a1.914,1.914,0,0,1-.351,2.2,2.328,2.328,0,0,1-1.26.8c-.119.027-.149.083-.143.2.01.192.005.385,0,.577a.64.64,0,0,1-1.179.365.943.943,0,0,1-.142-.645Z"
          transform="translate(-49.19 -227.377)"
          fill="currentColor"
        />
        <path
          id="Path_428"
          data-name="Path 428"
          d="M62.245,122.373c-.984,0-1.973-.049-2.954.009-2.357.14-4.716-.012-7.071.089-.953.041-1.905.036-2.857.055a1.4,1.4,0,0,1-1.345-1.237,1.251,1.251,0,0,1,1.307-1.277c2.778.047,5.554-.094,8.332-.083,1.143,0,2.288.064,3.426-.014,1.847-.125,3.691-.023,5.536-.061a1.382,1.382,0,0,1,1.418,1.175,1.307,1.307,0,0,1-1.4,1.273c-1.464.082-2.929.067-4.393.071Z"
          transform="translate(-43.017 -107.357)"
          fill="currentColor"
        />
        <path
          id="Path_429"
          data-name="Path 429"
          d="M53.256,166.5c.945,0,1.894.046,2.835-.009,2.4-.139,4.8.017,7.188-.09,1.23-.054,2.456-.027,3.684-.056a1.263,1.263,0,0,1,1.306.813,1.331,1.331,0,0,1-.42,1.492,1.126,1.126,0,0,1-.778.216c-1.825,0-3.653-.066-5.474.015-2.371.1-4.743-.032-7.109.082-1.558.075-3.113.023-4.668.056a1.276,1.276,0,0,1-1.409-1.175c-.027-.65.489-1.137,1.243-1.274a11.728,11.728,0,0,1,1.792-.067c.6-.016,1.207,0,1.811,0Z"
          transform="translate(-43.368 -149.01)"
          fill="currentColor"
        />
        <path
          id="Path_430"
          data-name="Path 430"
          d="M53.256,211.5c.945,0,1.894.046,2.835-.009,2.4-.139,4.8.017,7.188-.09,1.23-.054,2.456-.027,3.684-.056a1.263,1.263,0,0,1,1.306.813,1.331,1.331,0,0,1-.42,1.492,1.127,1.127,0,0,1-.778.216c-1.825,0-3.653-.066-5.474.015-2.371.1-4.743-.032-7.109.082-1.558.075-3.113.023-4.668.056a1.276,1.276,0,0,1-1.409-1.175c-.027-.65.489-1.137,1.243-1.274a11.728,11.728,0,0,1,1.792-.067c.6-.016,1.207,0,1.811,0Z"
          transform="translate(-43.368 -189.322)"
          fill="currentColor"
        />
        <text
          id="INVOICE-2"
          data-name="INVOICE"
          transform="translate(5.213 10.516)"
          fill="currentColor"
          fontSize="5"
          fontFamily="Aller Display"
        >
          <tspan x="0" y="0">
            IN
          </tspan>
          <tspan y="0" letterSpacing="-0.03em">
            V
          </tspan>
          <tspan y="0">OICE</tspan>
        </text>
      </g>
    </svg>
  );
}

export default InvoiceIcon;
